/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:94a1b585-574c-4194-97b7-f59e8075b4c7",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_N5FSepWyI",
    "aws_user_pools_web_client_id": "5icuj1muhu3847jbfmaiipo0r9",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://fztwvv565zafxh3wx5lwkb7rd4.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-o6p4alhj25c6hgctubnnh7gpxy",
    "aws_cloud_logic_custom": [
        {
            "name": "alplatformapi",
            "endpoint": "https://0mhafem87b.execute-api.us-west-2.amazonaws.com/develop",
            "region": "us-west-2"
        }
    ],
    "aws_user_files_s3_bucket": "alplatform-bucket91653-dev",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
